'use strict';
const angular = require('angular');

export class accountRequestComponent {

  constructor(RequestedUserService, dialogs, $scope, SettingsService, Config) {
    'ngInject';

    this.RequestedUserService = RequestedUserService;
    this.SettingsService = SettingsService;
    this.dialogs = dialogs;
    this.$scope = $scope;

    const generalConfig = Config.getModuleConfig(Config.Modules.General);
    const signUpConfig = Config.getModuleConfig(Config.Modules.SignUp);
    const profileConfig = Config.getModuleConfig(Config.Modules.Profile);

    this.buildings = generalConfig.getClientBuildings();
    this.unitNumbersByBuilding = generalConfig.getClientUnits();

    this.residencyRelationType = profileConfig.getResidencyRelationTypes();
    this.defaultResidencyRelationType = profileConfig.getDefaultResidencyRelationType();

    this.userProto = {
      userRequestType: 'request'
    };
    this.errors = {};
    this.submitted = false;

    this.form = ["*"];
    this.model = {};
  }


  getUnitsByBuilding(building) {
    // If there is no building selected, return an empty array
    if (typeof building == 'undefined')
      return [];

    return this.unitNumbersByBuilding[building];
  }

  $onInit() {
    this.config = this.resolve.config;
    this.type = this.config.type;

    this.userProto.userTargetType = this.type;

    this.SettingsService.getPublicByName({name: 'account-request-config'}, settings => {
      this.schema = settings.data[this.type].schema || {};
      this.title = settings.data[this.type].title || '';
      this.icon = settings.data[this.type].icon || '';
      this.info = settings.data[this.type].info || '';
      this.contactType = settings.data[this.type].contactType || 'Home';

      this.userProto.profile = {
        address: [{
          type: this.contactType
        }],
          phone: [{
          type: this.contactType
        }]
      };

      this.requiresResidencyStatus = settings.data[this.type].requiresResidencyStatus;

      if (this.requiresResidencyStatus) {

        this.userProto.residencyRelations = [
          {
            unit: '',
            building: '',
            type: this.type
          }
        ];
      }
    });
  };

  submit(form) {

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    var unflatten = require('flat').unflatten;

    this.user = angular.merge(this.userProto, unflatten(this.model,{delimiter:':'}));

    this.submitted = true;
    if (form.$valid) {

      if (this.type == 'realtor') {
        this.user.profile.about = [
          "Company: " + (this.user.customFields.company || '-'),
          "Website: " + (this.user.customFields.url || '-'),
          "License: " + (this.user.customFields.license || '-')
        ].join('\n');
      }

      this.user.profile.email = [{
        type: 'Work',
        address: this.user.email
      }];

      if (this.type == 'realtor') {
        let details = [
          "Name: " + this.user.firstName + " " + (this.user.middleName || '') + " " + this.user.lastName,
          "Company: " + (this.user.customFields.company || '-'),
          "Phone: " + (this.user.profile.phone[0].number || '-'),
          "Email: " + this.user.email,
          "Website: " + (this.user.customFields.url || '-'),
          "License: " + (this.user.customFields.license || '-'),
          "Address: " + (this.user.profile.address[0].street || '') + " " + (this.user.profile.address[0].street2 || '')
          + " " + (this.user.profile.address[0].city || '') + " " + (this.user.profile.address[0].state || '')
          + " " + (this.user.profile.address[0].zip || '') + " " + (this.user.profile.address[0].country || '')
        ].join('<br/>');

        this.user.customFields.details = details;
      } else if (this.requiresResidencyStatus) {
        let details = [
          "Name: " + this.user.firstName + " " + (this.user.middleName || '') + " " + this.user.lastName,
          "Phone: " + (this.user.profile.phone[0].number || '-'),
          "Email: " + this.user.email,
          "Building: " + this.user.residencyRelations[0].building,
          "Unit: " + this.user.residencyRelations[0].unit,
          "Address: " + (this.user.profile.address[0].street || '') + " " + (this.user.profile.address[0].street2 || '')
          + " " + (this.user.profile.address[0].city || '') + " " + (this.user.profile.address[0].state || '')
          + " " + (this.user.profile.address[0].zip || '') + " " + (this.user.profile.address[0].country || '')
        ].join('<br/>');

        this.user.customFields.details = details;
        this.user.customFields.residencyRelations = this.userProto.residencyRelations;
      } else {
        let details = [
          "Name: " + this.user.firstName + " " + (this.user.middleName || '') + " " + this.user.lastName,
          "Phone: " + (this.user.profile.phone[0].number || '-'),
          "Email: " + this.user.email,
          "Address: " + (this.user.profile.address[0].street || '') + " " + (this.user.profile.address[0].street2 || '')
          + " " + (this.user.profile.address[0].city || '') + " " + (this.user.profile.address[0].state || '')
          + " " + (this.user.profile.address[0].zip || '') + " " + (this.user.profile.address[0].country || '')
        ].join('<br/>');

        this.user.customFields.details = details;
      }

      return this.RequestedUserService.save(this.user, () => {
        this.dialogs.notify("Your request will be reviewed.","Your request will be reviewed.<br/>We will get back to you shortly.");
        this.close();
      }, (err) => {
        err = err.data;
        this.errors = {};
        // Update validity of form fields that match the mongoose errors
        if (err.name) {
          angular.forEach(err.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            this.errors[field] = error.message;
          });
        }
      });
    }
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.accountRequest', [])
  .component('accountRequest', {
    template: require('./account-request.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: accountRequestComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/account-request/account-request.component.js